import { SubscriberEngagementItemView } from "@tiny/api";

export interface ColumnDef {
  label: string;
  key: keyof SubscriberEngagementItemView;
  isPercent?: boolean;
  highlight?:
    | "opens-start"
    | "opens-end"
    | "clicks-start"
    | "clicks-end"
    | "spam-start"
    | "spam-end";
}

export const COLUMNS: ColumnDef[] = [
  { label: "Sent", key: "send" },
  { label: "Delivered", key: "delivered" },
  { label: "Opens", key: "opens", highlight: "opens-start" },
  {
    label: "Open Rate",
    key: "openRateOnDelivered",
    isPercent: true,
    highlight: "opens-end",
  },
  { label: "Clicks", key: "clicks", highlight: "clicks-start" },
  {
    label: "Click Rate",
    key: "clickRateOnDelivered",
    isPercent: true,
    highlight: "clicks-end",
  },
  { label: "Spam", key: "spam", highlight: "spam-start" },
  {
    label: "Spam Rate",
    key: "spamRateOnDelivered",
    isPercent: true,
    highlight: "spam-end",
  },
  { label: "Unsubscribes", key: "unsubscribe" },
  {
    label: "Unsubscribe/Click",
    key: "unsubscribeRateOnClick",
    isPercent: true,
  },
];

export function getDateRangeForDays(days: number): {
  from: number;
  to: number;
  timeZone: string;
} {
  const now = new Date();
  const to = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    23,
    59,
    59,
    999
  );
  const from = new Date(to.getTime() - (days - 1) * 24 * 60 * 60 * 1000);
  from.setHours(0, 0, 0, 0);
  return {
    from: from.getTime(),
    to: to.getTime(),
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
}

export function formatDay(epochMs: number): string {
  return new Date(epochMs).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
